import { ChevronLeft } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { URLdecode } from "../../utils/url";
import updateTaskStatus from "../../controllers/Tasks/updateStatus";
import Button1 from "../form/Button1";
import getTask from "../../controllers/Tasks/getTask";
import Icon from "../HOC/Icon";

const TicketManagementHeader = ({ title, reload, task, taskData }) => {
  const {id} = useParams();
  const {page} = URLdecode();
  const location = useLocation();
  const navigate = useNavigate();

  const handleBack = () => {
    if (location.pathname?.includes("detail")) {
      navigate("/order/");
    } else {
      navigate("/order/flight/ticket/detail/"+id);
    }
  };

  if(task && (!['Accepted','Declined']?.includes(taskData?.taskStatus)))
    return (
      <div className="flex justify-between items-center sm:mb-4 bg-[#F7F9FA] p-4 shadow-md w-full">
        <button
          className="bg-white text-black px-4 py-2 rounded-md border mr-3"
          onClick={handleBack}
        >
          Back
        </button>
        <TaskAcceptOption reload={reload} />
      </div>
    )
  
  return page ? (
    <div className="flex justify-between items-center sm:mb-4 bg-[#F7F9FA] py-2 shadow-md w-full">
      <div className="flex items-center gap-4">
        <div className="p-2 border-r cursor-pointer" onClick={handleBack}>
          <ChevronLeft />
        </div>
        <h2 className="text-lg font-bold">{title || "Order details"}</h2>
        {reload ? 
          <Icon icon='mdi:reload' className='cursor-pointer text-theme1' onClick={() => reload()} /> 
        :null}
      </div>
      <button
        className="bg-white text-black px-4 py-2 rounded-md border mr-3"
        onClick={handleBack}
      >
        Back
      </button>
    </div>
  ):null;
};

function TaskAcceptOption({reload}) {
  const [loadings,setLoadings] = useState({accept: false,decline: false})
  const {task} = URLdecode();

  async function handleAccept() {
    setLoadings({...loadings,accept: true})
    const res = await updateTaskStatus(task,{status: 'Accepted'})
    setLoadings({...loadings,accept: false})
    if(res?.return)
      reload && reload()
  }
  async function handleDecline() {
    setLoadings({...loadings,accept: true})
    const res = await updateTaskStatus(task,{status: 'Declined'})
    setLoadings({...loadings,accept: false})
    if(res?.return)
      reload && reload()
  }
  
  return (
    <div className="flex gap-4 items-center whitespace-nowrap">
      <Button1 loading={loadings?.decline} className="!rounded-md !btn-outlined !bg-secondary !text-primary"
        onClick={() => handleDecline()}
      >Decline</Button1>
      <Button1 loading={loadings?.accept} className="!rounded-md !btn-theme"
        onClick={() => handleAccept()}
      >Accept</Button1>
    </div>
  )
}

export default TicketManagementHeader;
